
define('ui-helper/flight-search-helper',[
		'jquery',
		'knockout',
		'underscore',
		'eteration/eteration-ajax',
		'eteration/ui/validation-helper',
		'ui-helper/cookie-helper',
		'ui-helper/storage-helper',
		'eteration/eteration-i18n',
		'eteration/eteration-urlparser',
		'jstorage'
],
function($, ko, underscore, etrAjax, validation, cookieHelper, storageHelper, i18n, urlParser) {

	var waitingPaxTypeRequest = false;
	
	function Pax(code, count) {
		var self = this;
		self.count = ko.observable(count);
		self.code = ko.observable(code);
		self.description;
		self.minAge = ko.observable();
		self.maxAge = ko.observable();
		self.paxCode;
		self.discountValid;
		self.hasNotMinAge = ko.observable();
		self.hasNotMaxAge = ko.observable();
		self.maxAgePlusLimit = 70;
		self.position;
		self.defaultOpen;
		self.restrictedCabinClass;
	}
	
	function DefaultPax(name, code, minAge, maxAge) {// used this object when "/paxtypecodes" error
		var self = this;
		self.paxName = name || 'ADULT';
		self.description = '<none>';
		self.canFlyAlone = false;
		self.cip = false;
		self.minAge = minAge || 12;
		self.maxAge = maxAge || 16;
		self.paxCode = code || 'ADULT';
		self.effectiveDate = null;
		self.expirationDate = null;
		self.defaultVisible = true;
		self.maxCount = 9;
		self.hasTooltip = false;
		self.position = 'LEFT';
		self.defaultOpen = true;
		self.assignedInfant = false;
		self.discountedType = false;
		self.domestic = false;
		self.international = false;
	}
	
	function FlightSearchData(loadPaxTypes, paxTypeCounts, awardTicketData, dateChangeCallbackActive, isStarAwardTicket) {
		
		var self = this;
				
		self.awardTicketData = awardTicketData;
		self.isStarAwardTicket = isStarAwardTicket;

		self.availabilityUrl = self.awardTicketData ? '/awardticketbooking' : '/booking';
		self.baseUrl = self.awardTicketData ? '/awardticketbooking' : '/booking';
		loadPaxTypes = typeof(loadPaxTypes) === "boolean" ? loadPaxTypes : true;
		paxTypeCounts = paxTypeCounts instanceof Array ? paxTypeCounts : [new Pax('ADULT', 1)];
		
		self.dateChangeCallbackActive = ko.observable(dateChangeCallbackActive || false);

		self.renderReady = ko.observable(false);
		self.initialFFCodes = ko.observable();
		self.initialCFFCode = ko.observable();

		self.initialFromPort = ko.observable();
		self.initialToPort = ko.observable();
		
		self.responseArrived = ko.observable(false);
		self.selectedPortDataOrigin = ko.observable();
		self.selectedPortDataDestination = ko.observable();
		
		self.multicityInternational = ko.observable(false);

		self.showMore = ko.observable(false);

		self.initialOriginAirportCode = ko.observable();
		self.initialDestinationAirportCode = ko.observable();
		
		self.originAirportCode = ko.observable();
		self.allOriginPorts = ko.observable(false);
		self.originCity = ko.observable();

		self.selectedCurrencyCode = null;
		self.cabinClass = ko.observable('ECONOMY');
		self.destinationAirportCode = ko.observable();
		self.allDestinationPorts = ko.observable(false);
		self.destinationCity = ko.observable();
		 
		self.oneWay = ko.observable(true);

		self.typeForPetcAvih = ko.observable("");
		self.widhtForPetcAvih = ko.observable("");
		self.sizeForPetcAvih = ko.observable("");
		self.heigthForPetcAvih = ko.observable("");
		self.weightForPetcAvih = ko.observable("");
		self.selectedAnimalGenus = ko.observable("");
		self.allGenusForPetcAvih = ko.observableArray();


		self.originationDateTime = ko.observable();
		self.returnDateTime = ko.observable();

		self.selectedStopoverNight = ko.observable();
		self.selectedStopoverPort = ko.observable();
		
		self.mexicanWaveActivationSwitchForFrom = ko.observable(true);
		self.mexicanWave = ko.observable(true);
		if(window.isPhone) {
			self.mexicanWaveActivationSwitchForFrom(false);
		}

		self.disabledRanges = ko.observableArray([]);
		
		self.paxList = ko.observableArray();
		
		self.paxLimits = ko.observable();
		
		self.maximumDaysForAvailability = ko.observable();

		self.savedSequence = ko.observable();
		
		self.routeRestrictionMessage = ko.observable('');
		
		self.savedDate = ko.observable();
		
		self.oneWayWeeklyViewInitialyOpen = ko.observable(false);
		self.roundTripMatrisViewInitiallyOpen = ko.observable(false);
		
		self.flexibleDates = ko.observable(false);

		self.filters = { directFlight : ko.observable(false) };
		
		self.dateDoneDisabled = ko.computed(function(){
			
			var d1 = self.originationDateTime();
			
			var enabled = false;
			
			if(self.oneWay()){
				if(!validation.isEmptyValue(d1))
					enabled = true;
			} else {
				if(!validation.isEmptyValue(d1)) {
					enabled = true;
				}
			}
			
			return !enabled;
		});

		if(window.isPhoneOrTablet && !window.animatedLeft) {
			setTimeout(function() {
				window.animatedLeft = true;
				$('.general-booker .booker-menu').animate({scrollLeft: 100 }, 350, 'easeInQuad').animate({scrollLeft: 0 }, 650, 'easeOutQuad');
			}, 1800);
		}
		
		$(document).on('focus','.general-booker input.form-control, #bookerManageTab input.form-control, #bookerDeparTab input.form-control, .deparr_booker_container input.form-control',function() {
			$(this).parents('.tk-input-field').find('.booker-text-label').addClass('active');
		});
		
		$(document).on('focusout','.general-booker input.form-control,#bookerManageTab input.form-control,#bookerDeparTab input.form-control',function() {
			var elem = $(this).parents('.tk-input-field').find('.booker-text-label');
			var fromStatusRoute = elem.attr('id') == 'from_status_route';
			var toStatusRoute = elem.attr('id') == 'to_status_route';
			var fromStatus = elem.attr('id') == 'from_status';
			var toStatus = elem.attr('id') == 'to_status';
			var memberStatus =  elem.attr('id') == 'member_status';
			
			if($(this).val() == '' &&
					( ((elem.attr('data-type') == 'from' && !self.originAirportCode()) || (elem.attr('data-type') == 'to' && !self.destinationAirportCode())) || 
							( elem.attr('for') == 'surname' || elem.attr('for') == 'ticketNo' ) ||
					  ( fromStatusRoute || toStatusRoute ) ||
					  ( toStatus || fromStatus ) || memberStatus  ) ){
				elem.removeClass('active');
			}			
		});
		
		self.dateSelectedDone = function(_data, event) {
			if (self.mexicanWave()) {
				self.mexicanWaveActivationSwitchForFrom(false);

				var d2 = self.returnDateTime();
				if (d2 == null || d2 == '') {
					self.oneWay(true);
				}

				setTimeout(function() {
					var elemId = $(event.target).parents('.calendar-holder').attr('id');
					$('.booker-content [href="#' + elemId + '"]').parents('.booker-content').find('#personCountBox').trigger('click');
				}, 400);
			} else {
				$("[href=#singleCityCalendarHolder]").first().focus();
			}
		};

		self.dateSelectedDoneForTravelPackage = function(_data, event) {
			if (self.mexicanWave()) {
				self.mexicanWaveActivationSwitchForFrom(false);

				var d2 = self.returnDateTime();
				if (d2 == null || d2 == '') {
					etrAjax.showErrorModal('Error-TP-Label-7005');
				} else {
					setTimeout(function() {
						var elemId = $(event.target).parents('.calendar-holder').attr('id');
						$('.booker-content [href="#' + elemId + '"]').parents('.booker-content').find('#personCountBoxForTravelPackage').trigger('click');
					}, 400);
				}


			} else {
				$("[href=#singleCityCalendarHolderForTravelPackage]").first().focus();

			}
		};
		
		self.chooseDateText = ko.pureComputed(function() {
			var oneWay = self.oneWay();
			var originationDateTimeEmpty = validation.isEmptyValue(self.originationDateTime())
			var returnDateTimeEmpty = validation.isEmptyValue(self.returnDateTime())

			//TEK YON VEYA HER IKI TARIH DOLU VEYA BOS ISE
			if(oneWay) {
				if(originationDateTimeEmpty) {
					return i18n.get('TextField-OB-49');
				} else {
					return i18n.get('TextField-OB-171');
				}
			} else if (originationDateTimeEmpty && returnDateTimeEmpty) {
				return i18n.get('TextField-OB-49');
			} else if (returnDateTimeEmpty) {
				return i18n.get('TextField-OB-170');
			} else {
				return i18n.get('TextField-OB-171');
			}
		});
		
		self.toggled = ko.observable(false);
		
		self.toggled.subscribe(function(newValue) {
		    if(newValue && !validation.isEmptyValue(self.originationDateTime()) && validation.isEmptyValue(self.returnDateTime()) && self.mexicanWave()){
		    	self.oneWay(true);
		    }
		});
		
		var generatePaxFromPaxInfoType = function(paxInfoType) {
			var pax = new Pax(paxInfoType.paxCode, 0);
			pax.minAge(paxInfoType.minAge);
			pax.maxAge(paxInfoType.maxAge - 1);
			pax.hasTooltip = paxInfoType.hasTooltip;
			pax.maxCount = paxInfoType.maxCount;
			pax.hasNotMinAge = pax.code() !== 'INFANT';
			pax.hasNotMaxAge = pax.maxAge() > pax.maxAgePlusLimit;
			pax.position = paxInfoType.position;
			pax.discountValid = paxInfoType.discount;
			pax.restrictedCabinClass = paxInfoType.restrictedCabinClass || '';
			pax.defaultOpen = paxInfoType.defaultOpen;
			return pax;
		}
	
		
		var generatePaxListFromPaxInfoTypes = function(paxInfoTypes, updateDefaultCounts) {
			var paxList = [];

			for (var paxInfoTypeIndex = 0; paxInfoTypeIndex < paxInfoTypes.length; paxInfoTypeIndex++) {

				var paxInfoType = paxInfoTypes[paxInfoTypeIndex];

				var pax = generatePaxFromPaxInfoType(paxInfoType);
				
				if(updateDefaultCounts && paxInfoType.paxCode === 'ADULT'){
					pax.count(1);
				}
				
				paxList.push(pax);
			}
			
			return paxList;
		}
		
		var processPaxTypes = function(paxInfoTypes, resetType) {
						
			resetType = resetType || 'hard_reset';
			var list;
			if (resetType === 'hard_reset' && !waitingPaxTypeRequest) {
				list = generatePaxListFromPaxInfoTypes(paxInfoTypes, true);
				self.paxList(list);
				return;
			}

			if (resetType === 'soft_reset') {

				var originalPaxList = self.paxList();

				var totalPaxCountBeforeReset = underscore.reduce(originalPaxList, function(totalPaxCount, pax){ return totalPaxCount + pax.count() }, 0);
				
				var newPaxList = generatePaxListFromPaxInfoTypes(paxInfoTypes, false);
				
				for (var originalPaxListIndex = 0; originalPaxListIndex < originalPaxList.length; originalPaxListIndex++) {
					
					var originalPax = originalPaxList[originalPaxListIndex];

					for (var newPaxListIndex = 0; newPaxListIndex < newPaxList.length; newPaxListIndex++) {
						
						var newPax = newPaxList[newPaxListIndex];

						if (originalPax.code() == newPax.code()) {
							newPax.count(originalPax.count());
							break;
						}
					}
				}
				
				var totalPaxCountAfterReset = underscore.reduce(newPaxList, function(totalPaxCount, pax){ return totalPaxCount + pax.count() }, 0);
				
				if(totalPaxCountAfterReset < 1 && newPaxList.length) {
					newPaxList[0].count(1);
					totalPaxCountAfterReset = 1;
				}
				
				if (totalPaxCountBeforeReset == totalPaxCountAfterReset) {
					self.paxList(newPaxList);
				} else {
					list = generatePaxListFromPaxInfoTypes(paxInfoTypes, false);
					self.paxList(list);
				}
				
				return;
			}
		}
		
		self.processPaxTypesFunction = function(paxInfoTypes, resetType) {
			processPaxTypes(paxInfoTypes, resetType);
		}
	
		// LOAD PAX TYPE ON INIT
		function getDefaultPaxType() {
			var obj = {
				"paxTypes": [],
				"limitMap":{
					"totalPaxCountInternational":9,
					"nonInfantCountInternational":7,
					"maxPaxCountDomesticWithTeacher":5,
					"totalPaxCountDomestic":15,
					"nonInfantCountDomestic":9,
					"maxPaxCountInternationalWithTeacher":5
				},
				"maximumDaysForAvailability":355
			}
			obj.paxTypes.push(new DefaultPax('ADULT', 'ADULT', 16, 130));
			obj.paxTypes.push(new DefaultPax('CHILD', 'CHILD', 2, 12));
			obj.paxTypes.push(new DefaultPax('INFANT', 'INFANT', 0, 8));
			
			if (self.originAirportCode() =="LGW" || self.originAirportCode()=="LHR" ) {
				obj.paxTypes.push(new DefaultPax('YOUNGADULT', 'YOUNGADULT', 12, 16));
			}
			return obj;
		}
		
		if(loadPaxTypes) {
			etrAjax.get({
				app : 'app.ibs',
				service : self.baseUrl + '/paxtypecodes',
				disableLoader : true,
				cache : true,
				callback : function(response) {
					var responseData = null
					if(response.data.paxTypes.length>0){
						responseData = response.data;
					}else{
						responseData = getDefaultPaxType();
					}						
					self.paxLimits(responseData.limitMap);
					self.maximumDaysForAvailability(responseData.maximumDaysForAvailability);
					processPaxTypes(responseData.paxTypes, 'hard_reset');
					self.updatePaxTypeCounts(paxTypeCounts, awardTicketData);
				}
			});
		}
		
		
		
		self.totalPaxCount =  ko.computed(function() {
	    	var count= 0;
	    	for (var int = 0; int < self.paxList().length; int++) {
				var p = self.paxList()[int];
				count+=  p.count();
			}
	    	return count;
	    });
		
		self.numberOfPassengersAriaString = ko.computed(function() {
			return i18n.get('Label-OB-05') +" "+ self.totalPaxCount();
		});
		
		self.clearDates = function() { };
		
		self.totalIconCount =  ko.computed(function() {

	    	var count= 0;

	    	for (var int = 0; int < self.paxList().length; int++) {
				var p = self.paxList()[int];
				count+=  p.count();
			}
	    	
	    	if(count>4){
	    		count = 4;
	    	}

	    	return count;
			
	    });
		
		self.paxCountByCode = function(code) {
			
	    	for (var paxListIndex = 0; paxListIndex < self.paxList().length; paxListIndex++) {	    
				if(self.paxList()[paxListIndex].code() == code){
					return self.paxList()[paxListIndex].count();
				}
	    	}

			return 0;
	    };
	    
		self.updatePaxList = function(list) {
			
			for (var int = 0; int < list.length; int++) {
				var element = list[int];
				var pax = new Pax(element.code, element.count);
				
				pax.minAge(element.minAge);
				pax.maxAge(element.maxAge);
				pax.hasTooltip = element.hasTooltip;
				pax.hasNotMinAge = pax.code() !== 'INFANT';
				pax.hasNotMaxAge = pax.maxAge() > pax.maxAgePlusLimit;
				self.paxList.push(pax);
			}
	    };
		
		self.updatePaxTypeCounts = function(codesAndCounts) {
			var originalPaxList = self.paxList();
			var paxCount;
			
			for (var originalPaxListIndex = 0; originalPaxListIndex < originalPaxList.length; originalPaxListIndex++) {
				
				var originalPax = originalPaxList[originalPaxListIndex];
				paxCount = 0;
				for (var key in codesAndCounts) {
					if (codesAndCounts.hasOwnProperty(key)) {
						if(codesAndCounts[key].code() == originalPax.code()){
							paxCount = codesAndCounts[key].count();
							break;
						}
					}
				}
				originalPax.count(paxCount);
			}
	    };
	    
		self.countAdult =  ko.computed(function() {
			return self.paxCountByCode('ADULT');
	    });
	
		self.countChild =  ko.computed(function() {
			return self.paxCountByCode('CHILD');
	    });
		
		self.countInfant =  ko.computed(function() {
			return self.paxCountByCode('INFANT');
		});
		
		self.countYoung =  ko.computed(function() {
			return self.paxCountByCode('YOUNGADULT');
		});
		
		self.countAdultOrEquivalent = ko.computed(function() {
			return self.totalPaxCount() - (self.countInfant() + self.countChild());
		});
		
		
		self.countNonInfant = ko.computed(function() {
			return self.totalPaxCount() - self.countInfant();
		});
		
		if(!awardTicketData) {
			self.countSoldier =  ko.computed(function() {
				return self.paxCountByCode('SOLDIER');
			});
			
			self.countStudent =  ko.computed(function() {
				return self.paxCountByCode('STUDENT');
			});
			
			self.countSenior =  ko.computed(function() {
				return self.paxCountByCode('SENIOR');
			});
			
			self.countTeacher =  ko.computed(function() {
				return self.paxCountByCode('TEACHER');
			});
			
			self.countDisabled =  ko.computed(function() {
				return self.paxCountByCode('DISABLED');
			});
			
			self.countYouth =  ko.computed(function() {
				return self.paxCountByCode('YOUTH');
			});

			self.countVeteran =  ko.computed(function() {
				return self.paxCountByCode('VETERAN');
			});
		}
		
		var limitCountTotalPax, limitCountNonInfant;
		
		self.validationMessage =  ko.computed(function() {

			if (!self.paxLimits()) {
				return '';
			}
			
			var totalPaxCount;
			var domesticOrigin = self.selectedPortDataOrigin() ? self.selectedPortDataOrigin().domestic : true;
			var domesticDestination = self.selectedPortDataDestination() ? self.selectedPortDataDestination().domestic : true;
			var multicityInternational = self.multicityInternational();
			

			var maxPaxCountInternationalBusinessCabin = self.paxLimits().maxPaxCountInternationalBusinessCabin;
			
			var domesticRoute = domesticOrigin && domesticDestination && !multicityInternational;
			var routeTypeText = domesticRoute ? i18n.get('routeType.domestic') : i18n.get('routeType.international');
			
			var countInfant = self.countInfant();
			var countNonInfant = self.countNonInfant();
			var awardTicketBookerWarning = window.kycMessageActive ? 'Error-BOS-29927' : 'Error-BOS-25071';

			if(self.cabinClass() == 'BUSINESS') {

				if (!domesticRoute && countNonInfant > maxPaxCountInternationalBusinessCabin) {
					return i18n.get('IBS.schedule.validationMessages.maxInternationalPaxCountForBusiness');
				}

			}
			
			if (countNonInfant > limitCountNonInfant) {
				return i18n.get('Error-BOS-25036');
			}
			
			if (countNonInfant == 0 && countInfant > 0) {
				return i18n.get('Error-OB-02');
			}
			
			var countAdultOrEquivalent = self.countAdultOrEquivalent();

			if (countAdultOrEquivalent == 0 && countInfant > 0) {
				return i18n.get('Error-OB-02');
			}
			
			if (countAdultOrEquivalent < countInfant) {
				return i18n.get('Error-BOS-25035');
			}
			
			totalPaxCount = self.totalPaxCount();
			
			if(!self.awardTicketData) {
				limitCountTotalPax = domesticRoute ? self.paxLimits().totalPaxCountDomestic : self.paxLimits().totalPaxCountInternational;
				limitCountNonInfant = domesticRoute ? self.paxLimits().nonInfantCountDomestic : self.paxLimits().nonInfantCountInternational;
				

				
				var restrictedValidationList = [];
				underscore.each(self.paxList(), function(value) {
					if(value.restrictedCabinClass && value.restrictedCabinClass != self.cabinClass() && value.count()) {
						var errorText = i18n.getWithArgs('Error-OB-72', {
							'cabinClass': value.restrictedCabinClass,
							'codeType': value.code(),
							'routeType': routeTypeText
						});
						restrictedValidationList.push(errorText);
						return;
					}
				});
				
				if(restrictedValidationList.length) {
					return restrictedValidationList[0];
				}
				
				if(!domesticRoute) {
					
					var countStudent = self.countStudent();
					if (countStudent && countStudent < totalPaxCount) {
						return i18n.get('Error-BOS-25067');
					}
					
					var countYouth = self.countYouth();
					if (countYouth && countYouth < totalPaxCount) {
						return i18n.get('Error-BOS-25067');
					}
					
					var countDisabled = self.countDisabled();
					if (countDisabled && countDisabled < countNonInfant) {
						return i18n.get('Error-BOS-25060');
					}

					var countVeteran = self.countVeteran();
					if (countVeteran && countVeteran < totalPaxCount) {
						return i18n.get('error.paxtype.veteranonly');
					}
				}
			} else {
				limitCountTotalPax = 5;
			
				if(self.isStarAwardTicket) {
					var countAdult = self.countAdult();
					var countChild = self.countChild();
		
					if(countAdult == 0 && countChild > 0) {			
						return i18n.get('Error-OB-04');
					}
				}
				
				if (!window.awardTicketBehalf) {
					if(self.countAdult() > 1 || self.countChild() > 0 || self.countInfant() > 0)
						return i18n.get(awardTicketBookerWarning);
				}
			}
			
			if (totalPaxCount > limitCountTotalPax) {
				return i18n.get('Error-BOS-25038');
			}
			
			if (totalPaxCount == 0) {
				return i18n.get('Error-BOS-25037');
			}
			
			return '';
	    });
		
		self.warningMessage =  ko.computed(function() {
			if(!self.isStarAwardTicket){
				var countAdult = self.countAdult();
				var countChild = self.countChild();
				
				for(var i = 0; i < self.paxList().length; i++) {
					if(self.paxList()[i].count() > 0 && self.paxList()[i].discountValid) {
						return i18n.get('Label-OB-194');
					}
				}
				
				if(countAdult == 0 && countChild > 0) {
					return i18n.get('Error-OB-03');
				}
			}
				
			return '';
	    });
		
		var updateByPortDataQuery = function(onlyPaxQuery){
			
			if(self.originAirportCode() && self.destinationAirportCode() && self.originAirportCode().length == 3 && self.destinationAirportCode().length == 3){
				if(!onlyPaxQuery){
					etrAjax.get({
						app : 'app.ibs',
						data:{'origin':self.originAirportCode(),'destination':self.destinationAirportCode()},
						service : '/booking/daterestrictions',
						cache : true,
						disableLoader : true,
						callback : function(response) {
							self.disabledRanges(response.data);
						}
					});
				}
				
				var originationDT=self.originationDateTime();
				var formattedOriginationDT = "";
				
				if(originationDT!=null&&originationDT != ''){
					formattedOriginationDT=moment.utc(self.originationDateTime()).format('YYYYMMDD');
				}
				
				var arrDT=self.returnDateTime();
				var formattedArrDT = "";
				
				if(arrDT) {
					formattedArrDT = moment.utc(self.returnDateTime()).format('YYYYMMDD');
				} else {
					formattedArrDT=self.returnDateTime();
				}
				
				var paxData  = {
					'origin':self.originAirportCode(),
					'destination':self.destinationAirportCode(),
					'depDate': formattedOriginationDT,
					'arrDate': formattedArrDT
				};
				
				etrAjax.get({
					app : 'app.ibs',
					data: paxData,
					service : self.baseUrl + '/paxtypecodes',
					disableLoader : true,
					cache : true,
					callback : function(response) {
						var responseData = null
						if(response.data.paxTypes.length>0){
							responseData = response.data;
						}else{
							responseData = getDefaultPaxType();
						}
						self.paxLimits(responseData.limitMap);
						processPaxTypes(responseData.paxTypes, 'soft_reset');
					}
				});
			}
		}
		
		self.originAirportCode.subscribe(function() {
			updateByPortDataQuery(false);
		});
		
		self.destinationAirportCode.subscribe(function() {
			updateByPortDataQuery(false);
		});
		
		self.dateChangeCallback = function(){
			self.dateChangeCallbackActive() && updateByPortDataQuery(true);
		};

		self.originationDateTime.subscribe(function() {
			!self.dateChangeCallbackActive() && updateByPortDataQuery(true);
		});
		
		self.returnDateTime.subscribe(function() {
			!self.dateChangeCallbackActive() && updateByPortDataQuery(true);
		});
	}
	
	function CheckSingleCityCalendar(flightSearchData) {
		var errors = [];

		var flightDateSelected = true;
		
		if (validation.isEmptyValue(flightSearchData.originationDateTime())) {
			flightDateSelected = false;
		}
		
		if ( (!flightSearchData.oneWay()) && validation.isEmptyValue(flightSearchData.returnDateTime())) {
			flightDateSelected = false;
		}
		
		if(!flightDateSelected){
			errors.push('Error-OB-12');
		}
		
		if (errors.length) {
			etrAjax.showErrorModal(errors);
			return false;
		}
		
		return true;
		
	}

	function CompleteAwardTicketSchedulePageSingleCity(flightSearchData, searchAttributes) {
		return CompleteSchedulePageSingleCity(flightSearchData, searchAttributes, true);
	}

	function CompleteStarAwardTicketSchedulePageSingleCity(flightSearchData, searchAttributes) {
		return CompleteSchedulePageSingleCity(flightSearchData, searchAttributes, false, true);
	}
	
	function ValidateAndPrepareBookerData(flightSearchData, searchAttributes, isAwardTicket, isStarAwardTicket) {

		var errors = [];

		if (validation.isEmptyValue(flightSearchData.originAirportCode())) {
			errors.push('Error-BOS-14016');
		}

		if (validation.isEmptyValue(flightSearchData.destinationAirportCode())) {
			errors.push('Error-BOS-14017');
		}
	
		if(flightSearchData.originAirportCode()!=null&&flightSearchData.destinationAirportCode()!=null&&flightSearchData.originAirportCode()==flightSearchData.destinationAirportCode()) {
			errors.push('Error-BOS-7123');
		} else {		
			//If Origin city and dest city is empty , let server site throw the error 
			if(flightSearchData.originCity() && flightSearchData.originCity().length  > 0 && flightSearchData.destinationCity() && flightSearchData.destinationCity().length  > 0){
				if(flightSearchData.originCity()==flightSearchData.destinationCity()){
					errors.push('Error-BOS-7123'); 
				}
			}	
		}
		var flightDateSelected = true;
		
		if (validation.isEmptyValue(flightSearchData.originationDateTime())) {
			flightDateSelected = false;
		}
		
		if ((!flightSearchData.oneWay()) && validation.isEmptyValue(flightSearchData.returnDateTime()) && flightDateSelected) {
			flightSearchData.oneWay(true);
		}
		
		if(!flightDateSelected){
			errors.push('Error-OB-12');
		}

		var infantCount = flightSearchData.countInfant();
		var nonInfantCount = flightSearchData.countNonInfant();

		if ((isAwardTicket || flightSearchData.awardTicketData) && flightSearchData.validationMessage()) {
			errors.push(flightSearchData.validationMessage());
		}else if(infantCount && infantCount != 0 && nonInfantCount == 0) {
			errors.push('Error-OB-25040');
		}else if (flightSearchData.validationMessage()) {
			errors.push('Error-BOS-25037');
		}

		if (errors.length) {
			etrAjax.showErrorModal(errors.reverse()[0]);
			return;
		}
		var bookings = BookingsFromFlightSearchDataList([flightSearchData]);
		
		var bookingRequest = {bookings : bookings, flexibleDates : flightSearchData.flexibleDates(), starAwardTicket : isStarAwardTicket};
		
		if(searchAttributes) {
			if(searchAttributes.selectedCurrencyCode) {
				bookingRequest.selectedCurrencyCode = searchAttributes.selectedCurrencyCode;
			}
			if(searchAttributes.selectedCabinClass) {
				bookingRequest.selectedCabinClass = searchAttributes.selectedCabinClass;
			}
			if(searchAttributes.sortSelections){
				bookingRequest.sortSelections = searchAttributes.sortSelections;
			}
			if(searchAttributes.filterSelections){
				bookingRequest.filterSelections = BookingFilterFromFilterDataList(searchAttributes.filterSelections);
			}
		}
		
		if(flightSearchData.accountCode) {
			bookingRequest.accountCode = flightSearchData.accountCode;
		}
		
		if(flightSearchData.tccBookingRequest) {
			bookingRequest.tccBookingRequest = true;
		}
		
		return bookingRequest;
		
	}

	function replaceEmptyReturnDateTimeWithNull (data) {
		data.bookings.map(function (booking) {
			if (booking.returnDateTime === "") {
				booking.returnDateTime = null;
			}
			return booking;
		});
		return data;
	}

	var STATIC_URLS = {
		AWARD: "awardTicketSelectFlight",
		STAR_AWARD: "starAwardTicketSelectFlight",
		DOMESTIC_SINGLE_CITY: "bookingBrandedDomesticAvailability",
		DOMESTIC_MULTI_CITY: "bookingBrandedDomesticAvailability",
		INTERNATIONAL_SINGLE_CITY: "bookingBrandedInternationalAvailability",
		INTERNATIONAL_MULTI_CITY: "bookingAvailabilityMultiCityInternational",
	};

	function createBookerParams(bookingRequest) {
		var flexibleDates = bookingRequest.flexibleDates;
		return bookingRequest.bookings.map(function (item) {
			return {
				directFlight: item.filters.directFlight,
				flexibleDates: flexibleDates
			}
		});
	}

	function CompleteSchedulePageSingleCity(flightSearchData, searchAttributes, isAwardTicket, isStarAwardTicket, links) {
		var bookingRequest = ValidateAndPrepareBookerData(flightSearchData, searchAttributes, isAwardTicket, isStarAwardTicket);
		
		if (!isStarAwardTicket) {
			var replacedData = replaceEmptyReturnDateTimeWithNull(bookingRequest);
			var service = "/api/v1/convert/to-new-availability-payload";
			$.ajax({
				method: "POST",
				url: service,
				data: JSON.stringify(replacedData),
				contentType: "application/json",
				success: function (response) {
					var data = response.data;
					if (data && response.success) {
						var payload = data.availabilityPayload;
						storageHelper.setItem({
							key: "availabilityPayload",
							value: JSON.stringify(payload),
							webStorageType: storageHelper.Stores.SESSION_STORAGE
						});
						storageHelper.setItem({
							key: "bookerParams",
							value: JSON.stringify(createBookerParams(bookingRequest)),
							webStorageType: storageHelper.Stores.SESSION_STORAGE
						});
						var redirect = STATIC_URLS[data.redirectPage];
						var availabilityPageUrlOnSchedule = links[redirect];

						window.location.href = availabilityPageUrlOnSchedule;
					} else {
						etrAjax.showErrorModal(["ERR-GENEL-08"]);
					}
				},
				error: function () {
					etrAjax.showErrorModal(["ERR-GENEL-08"]);
				}
			});
		} else {
			if(bookingRequest) {
				var controllerUrl = isAwardTicket ? '/awardticketbooking' : flightSearchData.availabilityUrl;
				var operation = '/completeschedulepagesinglecity' ;

				etrAjax.post({
					app : 'app.ibs',
					service : controllerUrl + operation,
					data : bookingRequest
				});
			}
		}
	}
	
	
	
	function FlightSearchDataErrors(flightSearchData) {
		
		var errors = [];

		if (validation.isEmptyValue(flightSearchData.originAirportCode()) || validation.isEmptyValue(flightSearchData.destinationAirportCode())) {
			errors.push('Error-BOS-EmptyPortCodes');
		}

		if (validation.isEmptyValue(flightSearchData.originationDateTime())) {
			errors.push('Error-OB-11');
		}
		
		if (flightSearchData.validationMessage()) {
			errors.push('Error-BOS-25037');
		}
		
		return underscore.unique(errors);
	}

	function ValidateAndPrepareMultipleBookerData(flightSearchDataList, searchAttributes) {
		var errors = [];

		for (var i = 0; i < flightSearchDataList.length; i++) {
			var flightSearchData = flightSearchDataList[i];
			var flightSearchDataErrors = FlightSearchDataErrors(flightSearchData);
			errors = underscore.union(errors, flightSearchDataErrors);
		}

		if (errors.length) {
			etrAjax.showErrorModal(errors);
			return;
		}

		var originationDatesOrdered = underscore.every(flightSearchDataList, function(value, index, array) {
			return index === 0 || array[index - 1].originationDateTime() <= value.originationDateTime();
		});

		if (!originationDatesOrdered) {
			errors.push('Error-OB-153');
		}

		if (errors.length) {
			etrAjax.showErrorModal(errors);
			return;
		}

		var bookings = BookingsFromFlightSearchDataList(flightSearchDataList);
		var bookingRequest = {bookings : bookings};

		if(searchAttributes) {
			if(searchAttributes.selectedCurrencyCode) {
				bookingRequest.selectedCurrencyCode = searchAttributes.selectedCurrencyCode;
			}
			if(searchAttributes.selectedCabinClass) {
				bookingRequest.selectedCabinClass = searchAttributes.selectedCabinClass;
			}
			if(searchAttributes.sortSelections){
				bookingRequest.sortSelections = searchAttributes.sortSelections;
			}
			if(searchAttributes.filterSelections){
				bookingRequest.filterSelections = BookingFilterFromFilterDataList(searchAttributes.filterSelections);
			}
		}

		return bookingRequest;
	}
	
	
	
	
	function CompleteSchedulePageMultipleCity(flightSearchDataList, searchAttributes) {
		var bookingRequest = ValidateAndPrepareMultipleBookerData(flightSearchDataList, searchAttributes);

		if(bookingRequest) {
			etrAjax.post({
				app : 'app.ibs',
				service : '/booking/completeschedulepagemulticity',
				data :bookingRequest
			});
		}
	}

	function CompleteSchedulePageStopover(flightSearchDataList, searchAttributes) {
		var bookingRequest = ValidateAndPrepareMultipleBookerData(flightSearchDataList, searchAttributes);

		if(bookingRequest) {
			bookingRequest.bookerSearchType = "STOPOVER";
			etrAjax.post({
				app : 'app.ibs',
				service : '/booking/completeschedulepagesinglecity',
				data :bookingRequest
			});
		}

	}
	
	function CompleteSchedulePageDynamicMultipleCity(flightSearchDataList, ajaxRequest) {
		var bookings = BookingsFromFlightSearchDataList(flightSearchDataList);
		var bookingRequest = { bookings : bookings }
		ajaxRequest.data = bookingRequest;
		etrAjax.post(ajaxRequest);
	}
	

	function FlightSearchDataFromBooking(booking, awardTicketData) {
		var data = new FlightSearchData(false, null, awardTicketData);
		data.originAirportCode(booking.originAirport.code);
		data.destinationAirportCode(booking.destinationAirport.code);
		
		if(moment(moment().format('MM/DD/YYYY')).diff(moment(booking.originationDateTime).format('MM/DD/YYYY'),'days')<=0){
			data.originationDateTime(booking.originationDateTime ? new Date(booking.originationDateTime) : null);
			data.returnDateTime(booking.returnDateTime ? new Date(booking.returnDateTime) : null);
		}
		
		data.oneWay(booking.oneWay);
		data.cabinClass(booking.cabinClass || 'ECONOMY');
		data.originCity(booking.originAirport.city ? booking.originAirport.city.name : '');
		data.destinationCity(booking.destinationAirport.city ? booking.destinationAirport.city.name : '');
		data.updatePaxList(booking.paxList);
		data.allDestinationPorts(booking.destinationAirport.multi);
		data.allOriginPorts(booking.originAirport.multi);
		data.savedDate(booking.savedDate);
		data.initialFromPort(booking.originAirport);
		data.initialToPort(booking.destinationAirport);
		data.selectedStopoverNight(booking.selectedStopoverNight);
		data.selectedStopoverPort(booking.selectedStopoverPort);
		data.responseArrived(true);
		data.renderReady(true);
		return data;
		
	}
	
	function FlightSearchDataFromPreviousBooking(booking, awardTicketData) {
		var data = new FlightSearchData(false, null, awardTicketData);
		
		var pList = booking.passsengerList;
		var passengerList = [];
		for (var key in pList) {
			passengerList.push({code : key , count : pList[key]});
		}
		data.updatePaxList(passengerList);

		data.originAirportCode(booking.departureAirport);
		data.destinationAirportCode(booking.arrivalAirport);
		
		data.originationDateTime(new Date(booking.departureDate));
		if (booking.returnDate) {
			data.oneWay(false);
			data.returnDateTime(new Date(booking.returnDate));
		}

		data.allDestinationPorts(booking.multiArrival);
		data.allOriginPorts(booking.multiDeparture);
		return data;
	}
	
	
	function FlightSearchDataListFromBookings(bookings, awardTicketData) {

		var flightSearchDataList = [];

		for (var bookingIndex = 0; bookingIndex < bookings.length; bookingIndex++) {
			var booking = bookings[bookingIndex];
			var flightSearchData = FlightSearchDataFromBooking(booking, awardTicketData);
			flightSearchDataList.push(flightSearchData);
		}

		return flightSearchDataList;

	}
	
	
	function BookingFilterFromFilterDataList(filterDataList){
		
		var list = ko.unwrap(filterDataList);
		
		var bookingFilters = [];
		
		for (var i = 0; i < list.length; i++) {
			var filterData = list[i];
			var bookingFilter = BookingFilterFromFilterData(filterData);
			bookingFilters.push(bookingFilter);
		}
		
		return bookingFilters;
	}
	
	function BookingFilterFromFilterData(filterData){
				
		var bookingFilter = {};
		
		bookingFilter.timeRangeStartIndex = filterData.timeRangeStartIndex();
		bookingFilter.timeRangeEndIndex = filterData.timeRangeEndIndex();
		bookingFilter.timeRangeStartValue = filterData.timeRangeStartValue();
		bookingFilter.timeRangeEndValue = filterData.timeRangeEndValue();
		bookingFilter.filterCssClass = filterData.filterCssClass();
		bookingFilter.panelVisible = filterData.panelVisible();
		bookingFilter.optionFiltersEditable = filterData.optionFiltersEditable();
		bookingFilter.optionFiltersAvailable = filterData.optionFiltersAvailable();
		bookingFilter.timeRangeFiltersAvailable = filterData.timeRangeFiltersAvailable();
		bookingFilter.stopFilterOptions = filterData.stopFilterOptions();
		bookingFilter.airlineFilterOptions = filterData.airlineFilterOptions();
		bookingFilter.originAirportFilterOptions = filterData.originAirportFilterOptions();
		bookingFilter.destinationAirportFilterOptions = filterData.destinationAirportFilterOptions();
		bookingFilter.selectedStopFilters = filterData.selectedStopFilters();
		bookingFilter.selectedAirlineFilters = filterData.selectedAirlineFilters();
		bookingFilter.selectedOriginAirportFilters = filterData.selectedOriginAirportFilters();
		bookingFilter.selectedDestinationAirportFilters = filterData.selectedDestinationAirportFilters();
		
		return bookingFilter;
	}
	
	function BookingFromFlightSearchData(flightSearchData) {

		var savedDate = flightSearchData.savedDate();
		var rph = flightSearchData.rph ? flightSearchData.rph : -1;
		var originAirportCode = flightSearchData.originAirportCode();
		var destinationAirportCode = flightSearchData.destinationAirportCode();
		var allOriginPorts = flightSearchData.allOriginPorts();
		var allDestinationPorts = flightSearchData.allDestinationPorts();
		var oneWay = flightSearchData.oneWay();
		var cabinClass = flightSearchData.cabinClass();
		var originationDateTime = flightSearchData.originationDateTime();
		var flightNumberList = flightSearchData.flightNumberList || [];

		var initialCFFCode = flightSearchData.initialCFFCode();
		var initialFFCodes = flightSearchData.initialFFCodes();
		var initialCFFCodes = flightSearchData.initialCFFCodes;


		var selectedStopoverNight = flightSearchData.selectedStopoverNight();
		var selectedStopoverPort = flightSearchData.selectedStopoverPort();

		if (!savedDate) {
			savedDate = moment().format('DD/MM/YYYY');
		}
		
		if(originationDateTime && originationDateTime.toDate){
			originationDateTime = originationDateTime.toDate();
			originationDateTime.setTime( originationDateTime.getTime() - originationDateTime.getTimezoneOffset()*60*1000 );
		}
		
		var returnDateTime = flightSearchData.returnDateTime();
		
		if(returnDateTime && returnDateTime.toDate){
			returnDateTime = returnDateTime.toDate();
			returnDateTime.setTime( returnDateTime.getTime() - returnDateTime.getTimezoneOffset()*60*1000 );
		}
		
		var oneWayWeeklyViewInitialyOpen = flightSearchData.oneWayWeeklyViewInitialyOpen()
		
		var passengers = flightSearchData.paxList();

		var portDataOrigin = flightSearchData.selectedPortDataOrigin();
		var portDataDestination = flightSearchData.selectedPortDataDestination();

		// com.thy.ws.client.booking.model.Booking
		var booking = {};
		
		if (portDataOrigin && portDataDestination) {
			booking.originAirport = {
				code : portDataOrigin.code,
				domestic : portDataOrigin.domestic,
				multi : portDataOrigin.multi
			};
			
			booking.destinationAirport = {
				code : portDataDestination.code,
				domestic : portDataDestination.domestic,
				multi : portDataDestination.multi
			};
		} else{
			booking.originAirport = {
				code : originAirportCode,
				multi : allOriginPorts
			};
			
			booking.destinationAirport = {
				code : destinationAirportCode,
				multi : allDestinationPorts
			};
		}
		
		
		booking.rph = rph;
		booking.oneWayWeeklyViewInitialyOpen = oneWayWeeklyViewInitialyOpen;
		booking.roundTripMatrisViewInitiallyOpen = flightSearchData.roundTripMatrisViewInitiallyOpen();

		booking.oneWay = oneWay;
		booking.cabinClass = cabinClass;
		booking.originationDateTime = originationDateTime;
		booking.returnDateTime = returnDateTime;
		booking.paxList = [];
		
		booking.initialCFFCode = initialCFFCode;
		booking.initialCFFCodes = initialCFFCodes;
		booking.initialFFCodes = initialFFCodes;
		booking.savedDate = savedDate;
		booking.flightNumberList = flightNumberList;

		if (selectedStopoverNight && selectedStopoverPort) {
			booking.selectedStopoverNight = selectedStopoverNight;
			booking.selectedStopoverPort = selectedStopoverPort;
		}
		
		for (var passengerIndex = 0; passengerIndex < passengers.length; passengerIndex++) {
			var element = passengers[passengerIndex];
			if(element.count()>0){
				booking.paxList.push({code : element.code() , count : element.count(), minAge: element.minAge(), maxAge: element.maxAge(), hasTooltip : element.hasTooltip });
			}
		}

		booking.filters = flightSearchData.filters && ko.toJS(flightSearchData.filters);
	
		return booking;
		
	}
	
	
	function BookingsFromFlightSearchDataList(flightSearchDataList) {

		var list = ko.unwrap(flightSearchDataList);
		
		var bookings = [];

		for (var searchDataIndex = 0; searchDataIndex < list.length; searchDataIndex++) {
			var flightSearchData = list[searchDataIndex];
			var booking = BookingFromFlightSearchData(flightSearchData);
			bookings.push(booking);
		}

		return bookings;

	}
	
	
	function updatePreviousSearchesSearchData(flightSearchData, loggedIn, maxPreviousSearch) {
		updatePreviousSearchesSearchDataClientSide(flightSearchData, maxPreviousSearch);
		if (loggedIn) {
			updatePreviousSearchesSearchDataServerSide(flightSearchData);
		}

	}
	
	function updatePreviousSearchesSearchDataClientSide(flightSearchData, maxPreviousSearch) {

		var errors = FlightSearchDataErrors(flightSearchData);

		if (errors.length) {
			return;
		}

		var previousSearchBookings = getPreviousSearchBookingsFromLocalStorage();
		var booking = BookingFromFlightSearchData(flightSearchData);

		for (var i = 0; i < previousSearchBookings.length; i++) {
			if (previousSearchBookings[i].destinationAirport.code == booking.destinationAirport.code && previousSearchBookings[i].originAirport.code == booking.originAirport.code && previousSearchBookings[i].oneWay == booking.oneWay && $.datepicker.formatDate("dd/mm/yyyy", new Date(previousSearchBookings[i].originationDateTime)) == $.datepicker.formatDate("dd/mm/yyyy", new Date(booking.originationDateTime)) && $.datepicker.formatDate("dd/mm/yyyy", new Date(previousSearchBookings[i].returnDateTime)) == $.datepicker.formatDate("dd/mm/yyyy", new Date(booking.returnDateTime))) {
				previousSearchBookings.splice(i, 1);
				break;
			}
		}

		var maxPrevSearch = maxPreviousSearch || 10;
		previousSearchBookings.unshift(booking);
		if (maxPrevSearch < previousSearchBookings.length) {
			previousSearchBookings.splice(maxPrevSearch, previousSearchBookings.length);
		}

		setPreviousSearchBookingsToLocalStorage(previousSearchBookings);
	}

	function updatePreviousSearchesSearchDataServerSide(flightSearchData) {

		var errors = FlightSearchDataErrors(flightSearchData);

		if (errors.length) {
			return;
		}

		var newSearchBooking = BookingFromFlightSearchData(flightSearchData);

		var bookingRequest = {};
		var bookings = [];
		bookings[0] = newSearchBooking;

		bookingRequest.bookings = bookings;

		setPreviousSearchBookingsToServer(bookingRequest);

	}

	function setPreviousSearchBookingsToServer(bookingRequest) {
		etrAjax.post({
			app : 'app.ibs',
			service : '/booking/bookingsavepreviousflight',
			data : {
				'bookingRequest' : bookingRequest

			},
			callback : function() { }
		});

	}
	
	function getPreviousSearchBookingsFromLocalStorage() {

		var previousSearchBookings = null;

		try {

			previousSearchBookings = JSON.parse($.jStorage.get("app.ibs/ibs/previoussearchbookings"));

			previousSearchBookings = $.isArray(previousSearchBookings) ? previousSearchBookings : [];

		} catch (e) {
			previousSearchBookings = [];
		}

		for (var previousSearchBookingsIndex = previousSearchBookings.length - 1; previousSearchBookingsIndex >= 0; previousSearchBookingsIndex--) {

			var previousSearchBooking = previousSearchBookings[previousSearchBookingsIndex];

			if (!previousSearchBooking.savedDate || moment().diff(moment(previousSearchBooking.savedDate, 'DD/MM/YYYY'), 'months') > 3) {
				previousSearchBookings.splice(previousSearchBookingsIndex, 1);
			}

		}

		return previousSearchBookings;

	}

	function setPreviousSearchBookingsToLocalStorage(previousSearchBookings) {

		var json = JSON.stringify(previousSearchBookings);

		$.jStorage.set("app.ibs/ibs/previoussearchbookings", json);

	}
	
	function setLastSelectedFlightToBeUsed(){
		if(urlParser.getUrlVar("cId") != null){
			etrAjax.get({
				app : 'app.ibs',
				service : '/booking/setlastselectedflighttobeused',
				disableLoader : true,
				disableErrorHandling: true,
				callback : function(response) {

				}
			});
		}
	}

	return {
		
		Pax : Pax,
		FlightSearchData : FlightSearchData,
				
		FlightSearchDataFromBooking : FlightSearchDataFromBooking,
		FlightSearchDataFromPreviousBooking: FlightSearchDataFromPreviousBooking,
		FlightSearchDataListFromBookings : FlightSearchDataListFromBookings,
		
		BookingFromFlightSearchData : BookingFromFlightSearchData,
		BookingsFromFlightSearchDataList : BookingsFromFlightSearchDataList,
		
		
		FlightSearchDataErrors : FlightSearchDataErrors,
		
		
		CompleteSchedulePageSingleCity : CompleteSchedulePageSingleCity,
		CompleteSchedulePageMultiCity : CompleteSchedulePageMultipleCity,
		CompleteSchedulePageStopover : CompleteSchedulePageStopover,
		CompleteSchedulePageDynamicMultipleCity: CompleteSchedulePageDynamicMultipleCity,
		CheckSingleCityCalendar : CheckSingleCityCalendar,
		CompleteAwardTicketSchedulePageSingleCity: CompleteAwardTicketSchedulePageSingleCity,
		CompleteStarAwardTicketSchedulePageSingleCity: CompleteStarAwardTicketSchedulePageSingleCity,
		ValidateAndPrepareBookerData : ValidateAndPrepareBookerData,
		
		updatePreviousSearchesSearchData: updatePreviousSearchesSearchData,
		setPreviousSearchBookingsToLocalStorage: setPreviousSearchBookingsToLocalStorage,
		getPreviousSearchBookingsFromLocalStorage: getPreviousSearchBookingsFromLocalStorage,
		setLastSelectedFlightToBeUsed: setLastSelectedFlightToBeUsed
	};

});
